import { Link } from "react-router-dom";
import clsx from "clsx";

import { FileModel, AttachmentModel } from "@interfaces/index";
import { formatFilesize, isFilePreviewable } from "@utils/index";
import { FileCheckSvg, TrashSvg, DownloadSvg } from "@components/index";

export const FileItem = ({
  isEditing = true,
  file,
  onRemove,
  onPreview,
}: {
  isEditing?: boolean;
  file: FileModel | AttachmentModel;
  onRemove?: (uuid: string) => void;
  onPreview?: (attachment: AttachmentModel) => void;
}) => {
  const fileId =
    (file as FileModel)?.uuid || (file as AttachmentModel)?.uniqueId;

  return (
    <div className="flex items-center justify-between rounded-lg bg-primary-104 p-4">
      <div className="flex items-center gap-x-4">
        <div className="rounded-lg bg-primary-300 p-2.5 text-white-100 *:size-[20px]">
          <FileCheckSvg />
        </div>
        <div>
          {isEditing || !onPreview ? (
            <div className="max-w-60 truncate text-300 text-black-100 md:max-w-72">
              {file.originalName}
            </div>
          ) : (
            <button
              type="button"
              className={clsx(
                "text-300 text-black-100 hover:underline",
                !isFilePreviewable(file) && "pointer-events-none",
              )}
              onClick={() => onPreview(file as AttachmentModel)}
            >
              {file.originalName}
            </button>
          )}
          {!!file.size && (
            <div className="font-light text-black-54">
              File size / {formatFilesize(file.size)}
            </div>
          )}
        </div>
      </div>
      {onRemove && (
        <button
          type="button"
          className="text-black-54"
          onClick={() => onRemove(fileId)}
        >
          <TrashSvg />
        </button>
      )}
      {!isEditing && (
        <Link
          to={(file as AttachmentModel).url || "#"}
          target="_blank"
          className="text-black-54"
        >
          <DownloadSvg />
        </Link>
      )}
    </div>
  );
};
